import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

const MutualFundDisclaimer = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Mutual Fund Disclaimer - Wisdom Consultancy</title>
      </Helmet>

      <section className="bg-gray-50 py-20 min-h-screen">
        <div className="container-custom max-w-4xl bg-white rounded-3xl shadow-xl p-8 md:p-14 border border-gray-100">
          <h1 className="text-4xl md:text-5xl font-extrabold text-[#0b1c39] mb-8 border-b pb-6">
            Mutual Fund Disclaimer & Disclosure
          </h1>

          <div className="prose prose-lg text-gray-600 max-w-none space-y-6">
            <p>
              By accessing and using this website, you acknowledge that you have read, understood, and agreed to the terms of this disclaimer.
            </p>
            <p>
              Yagneshkumar Rajeshbhai Dole is an AMFI Registered Mutual Fund Distributor holding valid ARN-185896 under the guidelines prescribed by the Association of Mutual Funds in India (AMFI).
            </p>
            <p>
              The information, calculators, articles, graphics, market views, and services provided on this website are intended solely for general informational and educational purposes and do not constitute investment advice, research recommendation, tax advice, legal advice, or solicitation to invest in any specific Mutual Fund scheme or financial product.
            </p>
            <p>
              <strong>Mutual Fund investments are subject to market risks including possible loss of principal. Please read all Scheme Information Documents (SID), Key Information Memorandum (KIM), Statement of Additional Information (SAI), and other related documents carefully before investing.</strong>
            </p>
            <p>
              Past performance of any Mutual Fund scheme, asset class, sector, SIP strategy, or investment approach does not guarantee future performance or returns.
            </p>
            <p>
              Investment values may fluctuate depending on market conditions, economic developments, interest rate movements, taxation changes, inflation, political conditions, and other external factors.
            </p>
            <p>
              Neither Wisdom Consultancy nor Yagneshkumar Rajeshbhai Dole guarantees:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Assured returns</li>
              <li>Capital protection</li>
              <li>Accuracy or completeness of market information</li>
              <li>Suitability of any scheme for every investor</li>
              <li>Future performance of any investment product</li>
            </ul>
            <p>
              Any investment decision taken by users shall be entirely at their own discretion and risk.
            </p>
            <p>
              Investors are strongly advised to evaluate their risk appetite, financial goals, liquidity requirements, and investment horizon before investing in Mutual Fund schemes.
            </p>
            <p>
              The website may contain links to third-party websites for investor convenience. Wisdom Consultancy does not control or endorse the content, accuracy, or availability of such external websites and shall not be responsible for any loss arising from their usage.
            </p>
            <p>
              All trademarks, logos, fund names, AMC names, and brand names displayed on this website belong to their respective owners and are used strictly for informational and identification purposes only.
            </p>
            <p>
              Wisdom Consultancy reserves the right to modify, update, or remove any content on this website without prior notice.
            </p>
            <p>
              For any investment-related queries, users are encouraged to contact the authorized distributor directly.
            </p>
            <div className="mt-8 p-6 bg-gray-50 rounded-xl border border-gray-200">
              <p className="font-bold text-gray-800">ARN Holder Details:</p>
              <p>Name: Yagneshkumar Rajeshbhai Dole</p>
              <p>ARN No: 185896</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MutualFundDisclaimer;
